import Typography from 'antd/lib/typography';
import React from 'react';
import Tooltip from 'antd/lib/tooltip';
import { ICompany } from '../../domain/company/interface';
import { ICloudVen, ICustomerVen } from '../../domain/ven/interface';
import { VenIcon } from '../VenIcon/VenIcon';

interface IVenInfoProps {
    ven?: ICloudVen | ICustomerVen | null;
    controlProvider?: ICompany | null;
}

export const VenInfo: React.FC<IVenInfoProps> = ({ ven, controlProvider }) => {
    if (!ven) return null;

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', maxWidth: '100%' }}>
            <span style={{ paddingRight: '12px' }}>
                <VenIcon ven={ven} controlProvider={controlProvider} />
            </span>

            <Tooltip placement="topLeft" title={ven.ven_id}>
                <Typography.Text ellipsis>{ven.ven_id}</Typography.Text>
            </Tooltip>
        </div>
    );
};
